module.exports = __webpack_public_path__ + "static/media/magic.1a61f9ed.svg";